import { Criteria, type CriteriaValue } from '@openx/types/targeting/targetingValuesTypes';
import { useMemo } from 'react';
import { StyledBox } from './components/StyledBox';
import { StyledBoxContainer } from './components/StyledBoxContainer';
import { useGetDimensionLabels } from './hooks/useGetDimensionLabels';

type DimensionChipLineProps = {
  showLabel?: boolean;
  targetingDimension?: CriteriaValue;
  switchState?: boolean;
  isSubsection?: boolean;
};

export const DimensionChipLine = ({
  showLabel = true,
  targetingDimension = Criteria.ALL,
  switchState,
  isSubsection = false,
}: DimensionChipLineProps) => {
  const { dimensionLabels } = useGetDimensionLabels();

  const dimensionLabel = useMemo(() => {
    if (typeof switchState !== 'undefined') {
      return switchState ? dimensionLabels[Criteria.ANY] : dimensionLabels[Criteria.ALL];
    }
    return dimensionLabels[targetingDimension];
  }, [dimensionLabels, targetingDimension, switchState]);

  const isOr = targetingDimension === Criteria.ANY || (typeof switchState !== 'undefined' && switchState === true);

  const pillIsRed = isSubsection || isOr;

  return (
    <StyledBoxContainer>
      {showLabel && (
        <StyledBox component="span" data-test="targeting-dimension-line" isInside={false} isSubsection={pillIsRed}>
          {dimensionLabel}
        </StyledBox>
      )}
    </StyledBoxContainer>
  );
};
